import { render } from "./profileBody.vue?vue&type=template&id=36758e3c&scoped=true"
import script from "./profileBody.vue?vue&type=script&lang=js"
export * from "./profileBody.vue?vue&type=script&lang=js"

import "./profileBody.vue?vue&type=style&index=0&id=36758e3c&scoped=true&lang=css"
import "./profileBody.vue?vue&type=style&index=1&id=36758e3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36758e3c"]])

export default __exports__